import React, { memo, useMemo, useEffect } from "react";

import "./HawkeyeV2DataViewer.scss";

function HawkeyeV2DataViewer(props) {
  const { data, onClose } = props;

  // Stop scrolling the overall page when modal is open
  useEffect(() => {
    document.body.classList.add("no-scroll");
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  const [tableColumns, tableData] = useMemo(() => {
    if (data && data.header.length > 1 && data.data.length > 1) {
      const columns = [];
      const tableData = [];
      return [data.header[1], data.data[1]];
    } else {
      return [[], []];
    }
  }, [data]);

  return (
    <div className="hawkeye-data-viewer">
      <div className="hawkeye-data-viewer-content">
        <div className="hawkeye-data-viewer-title">View Data</div>
        <div className="hawkeye-data-viewer-data nice-scroll">
          <table className="hawkeye-data-viewer-table">
            <thead>
              <tr>
                {tableColumns.map((c) => (
                  <th key={c}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.map((td, i) => (
                <tr key={i}>
                  {tableColumns.map((tc, i) => (
                    <td key={i}>{td[tc] ? td[tc] : ""}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="hawkeye-data-viewer-footer">
          <button onClick={onClose} type="button" className="hawkeye-btn hawkeye-btn-secondary">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default memo(HawkeyeV2DataViewer);
